module.exports = __webpack_public_path__ + "img/LI.b40f77a3.png";